import { CreditIQState } from "Types/state";
import { getCIQTokenFailure, getCIQTokenRequest, getCIQTokenSuccess } from "../actions/creditIQ";
import { ActionType } from "../dataService/actions/utils/actionCreator";

export const creditIQInitialState: Partial<CreditIQState> = {
    loading: false,
    error: false,
    tokenBundle: null,
};

function reducer(
    state: Partial<CreditIQState> = creditIQInitialState,
    action:
        | ActionType<typeof getCIQTokenRequest>
        | ActionType<typeof getCIQTokenSuccess>
        | ActionType<typeof getCIQTokenFailure>
): Partial<CreditIQState> {
    switch (action.type) {
        case getCIQTokenRequest.type:
            return { ...state, loading: true, error: false };

        case getCIQTokenSuccess.type:
            const { vin, tokenBundle } = action.payload;
            return {
                ...state,
                tokenBundle: { ...state.tokenBundle, [vin]: tokenBundle },
                loading: false,
                error: false,
            };

        case getCIQTokenFailure.type:
            return {
                ...state,
                error: true,
                loading: false,
            };

        default:
            return state;
    }
}

export default reducer;
